import { ADD_WAITLIST_INGREDIENTS_TO_GROCERYLIST } from "./actionTypes";

export default (ingredientData) => ({
  type: ADD_WAITLIST_INGREDIENTS_TO_GROCERYLIST,
  payload: {
    ingredientData
  },
});